/** Форматирование чисел под макет: две значащие цифры после точки. */
export function money(value: number): string {
  return value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function compact(value: number): string {
  return value.toLocaleString('en-US', { notation: 'compact', maximumFractionDigits: 1 });
}

/**
 * Выплата хранится ДОЛЕЙ (0.92 — так её понимает trade-engine), а людям
 * показывается процентом. Значения выше единицы считаем уже процентами.
 */
export function payoutPercent(payout: number): number {
  return payout <= 1 ? Math.round(payout * 100) : Math.round(payout);
}
